import { GET_FOLLOWUPS, UPDATE_FOLLOWUP } from "./FollowUpsActions";

const initialState = {
  followUps: [],
  totalCount: 0,
};

const FollowUpsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FOLLOWUPS:
      return {
        ...state,
        followUps: action.followUps || [],
        totalCount: action.totalCount || 0,
      };
    case UPDATE_FOLLOWUP:
      return {
        ...state,
        followUps: state.followUps.map((fu) =>
          fu.id === action.followUp.id ? action.followUp : fu
        ),
      };
    default:
      return state;
  }
};

export default FollowUpsReducer;
